import { render, staticRenderFns } from "./AddressNumber.vue?vue&type=template&id=014a439e&"
import script from "./AddressNumber.vue?vue&type=script&lang=ts&"
export * from "./AddressNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports